import React from "react";

export default React.createContext({
    current_page: 1,
    data: [],
    first_page_url: null,
    from: 1,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 5,
    prev_page_url: null,
    to: 1,
    total: 0,
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/Pagination/context.js